import { useState } from "react";
import { Input } from "@/components/ui/input";
import { DateInput } from "@/components/ui/date-input";

const iso = (d) => d.toISOString().slice(0, 10);
const today = () => { const d = new Date(); d.setHours(12, 0, 0, 0); return d; };
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

// Raccourcis communs à tous les modules (Achats, Activité, Lia…) : {start, end} au format YYYY-MM-DD
export const PERIOD_PRESETS = [
  ["today", "Aujourd'hui", () => { const t = today(); return { start: iso(t), end: iso(t) }; }],
  ["yesterday", "Hier", () => { const y = addDays(today(), -1); return { start: iso(y), end: iso(y) }; }],
  ["last7", "7 derniers jours", () => ({ start: iso(addDays(today(), -6)), end: iso(today()) })],
  ["last30", "30 derniers jours", () => ({ start: iso(addDays(today(), -29)), end: iso(today()) })],
  ["month", "Mois en cours", () => { const t = today(); return { start: iso(new Date(t.getFullYear(), t.getMonth(), 1, 12)), end: iso(t) }; }],
  ["prev_month", "Mois précédent", () => { const t = today(); return { start: iso(new Date(t.getFullYear(), t.getMonth() - 1, 1, 12)), end: iso(new Date(t.getFullYear(), t.getMonth(), 0, 12)) }; }],
  ["year", "Année en cours", () => { const t = today(); return { start: iso(new Date(t.getFullYear(), 0, 1, 12)), end: iso(t) }; }],
  ["custom", "Période personnalisée", null],
];

export const PeriodPicker = ({ value, onChange, testid = "period-picker", className = "" }) => {
  const [preset, setPreset] = useState(value?.preset || "last30");
  const pick = (key) => {
    setPreset(key);
    const p = PERIOD_PRESETS.find(([k]) => k === key);
    if (p && p[2]) onChange({ ...p[2](), preset: key });
    else onChange({ start: value?.start || iso(addDays(today(), -29)), end: value?.end || iso(today()), preset: "custom" });
  };
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={testid}>
      <select value={preset} onChange={(e) => pick(e.target.value)} className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm" data-testid={`${testid}-preset`}>
        {PERIOD_PRESETS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      {preset === "custom" && (<>
        <DateInput value={value?.start || ""} max={value?.end || undefined} onChange={(e) => onChange({ ...value, start: e.target.value, preset: "custom" })} className="h-9 w-40" data-testid={`${testid}-start`} />
        <span className="text-xs text-slate-400">→</span>
        <DateInput value={value?.end || ""} min={value?.start || undefined} onChange={(e) => onChange({ ...value, end: e.target.value, preset: "custom" })} className="h-9 w-40" data-testid={`${testid}-end`} />
      </>)}
      {value?.start && value?.end && <span className="text-xs text-slate-500 tabular-nums" data-testid={`${testid}-label`}>{new Date(value.start).toLocaleDateString("fr-FR")} – {new Date(value.end).toLocaleDateString("fr-FR")}</span>}
    </div>
  );
};
